import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LoadingButton from '@mui/lab/LoadingButton';
// components
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField, RHFSwitch } from 'src/components/hook-form';
// utils
import axios, { API_ENDPOINTS } from 'src/utils/axios';

// ----------------------------------------------------------------------

const schema = Yup.object().shape({
  date: Yup.string().required('A data é obrigatória'),
  reason: Yup.string().optional(),
  isRecurringYearly: Yup.boolean(),
});

const defaultValues = {
  date: '',
  reason: '',
  isRecurringYearly: false,
};

// ----------------------------------------------------------------------

export default function SpecialClosedDateForm({ open, onClose, onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      await axios.post(API_ENDPOINTS.businessHours.closedDates, {
        date: new Date(data.date).toISOString(),
        reason: data.reason || null,
        isRecurringYearly: data.isRecurringYearly,
      });

      enqueueSnackbar('Data especial adicionada com sucesso!', { variant: 'success' });
      reset();
      onSuccess();
    } catch (error) {
      console.error('Erro ao criar data especial:', error);
      enqueueSnackbar(error.message || 'Erro ao adicionar data especial', { variant: 'error' });
    }
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>Adicionar Data de Encerramento</DialogTitle>

        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <Stack spacing={3}>
              <RHFTextField
                name="date"
                label="Data"
                type="date"
                InputLabelProps={{ shrink: true }}
              />

              <RHFTextField
                name="reason"
                label="Motivo (opcional)"
                placeholder="Ex: Natal, Férias, Evento privado..."
              />

              <RHFSwitch
                name="isRecurringYearly"
                label="Repetir todos os anos"
                helperText="Ative para feriados fixos como Natal, Ano Novo, etc."
              />
            </Stack>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Cancelar
          </Button>

          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Adicionar
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}

SpecialClosedDateForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};
